import { createCRUDHook } from './createCRUDHook';
import { HardwareCategoryDto } from 'utils/models';
import { TBL_HARDWARE_CATEGORY } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<HardwareCategoryDto>({
    entityName: 'HardwareCategory',
    endpoint: TBL_HARDWARE_CATEGORY,
  });

export const HardwareCategoryContext = Context;
export const useHardwareCategoryManager = useManager;
export const useHardwareCategory = useConsumer;
